import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { editEntityInfo } from '../../../actions/entity-designer.actions';
import { ENTITY_INFO_DISABLED_PROPERTIES } from '../../../constants/entity-designer.constants';
import { getEntityProp } from '../../../selectors/entity-designer.selectors';

const useStyles = makeStyles({
  rowLabel: {
    paddingTop: 8,
    paddingRight: 8,
    alignItems: 'center',
    width: 200,
  },
  rowColumn: {
    flex: 1,
    alignItems: 'center',
    '& div': {
      margin: 0,
    },
  },
});

const TextBoxControl = ({ prop, label, disabled }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const currentValue = useSelector((state) => getEntityProp(state, { prop }));

  const [value, setValue] = useState(currentValue);

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const handleBlur = ({ target: { value: v } }) => {
    const _value = v.trim();

    if (_value === currentValue) {
      return;
    }

    dispatch(editEntityInfo({ prop, value: _value }));
  };

  const isDisabled = disabled || ENTITY_INFO_DISABLED_PROPERTIES.includes(prop);

  return (
    <>
      <div className={classes.rowLabel}>
        <Typography>{translateString(label)}</Typography>
      </div>
      <div className={classes.rowColumn}>
        <TextField
          fullWidth
          size="small"
          value={value ?? ''}
          disabled={isDisabled}
          onChange={({ target }) => setValue(target.value)}
          onBlur={handleBlur}
          InputProps={{
            inputProps: {
              'aria-label': translateString(label),
            },
          }}
        />
      </div>
    </>
  );
};

export default TextBoxControl;
